import React from 'react';
import { Link } from 'react-router-dom';
import { Event } from '../types';
import './EventCard.scss';

interface EventCardProps {
  event: Event;
}

const EventCard: React.FC<EventCardProps> = ({ event }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return {
      day: date.getDate().toString().padStart(2, '0'),
      month: date.toLocaleDateString('en-US', { month: 'short' }),
      time: date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      })
    };
  };

  const dateInfo = formatDate(event.starts);

  return (
    <Link to={`/events/${event.slug}`} className="event-card-link">
      <div className="event-card">
        <div className="card-media p-0">
          <picture>
            <source media="(max-width: 1139px)" srcSet={event.banner_url} />
            <source media="(min-width: 1140px)" srcSet={event.thumbnail_url} />
            <img
              src={event.banner_url}
              alt={`${event.title} Banner`}
              loading="lazy"
              style={{ width: '100%', borderRadius: 0 }}
            />
          </picture>

          {event.is_highlight && (
            <div className="highlight-badge">
              <i className="fas fa-star"></i> Featured
            </div>
          )}

          {event.is_live && event.status === 'ongoing' && (
            <div className="live-badge">
              <span className="pulse"></span>
              <span>LIVE</span>
            </div>
          )}

          <div className="card-date">
            <span className="day">{dateInfo.day}</span>
            <span className="month">{dateInfo.month}</span>
          </div>

          {event.min_price === 0 && (
            <div className="free-badge">
              <span>Free</span>
            </div>
          )}
        </div>

        <div className="card-content">
          <h3 className="card-title text-truncate">{event.title}</h3>
          <div className="venue-info">
            <div className="venue text-truncate">
              <i className="fas fa-map-marker-alt icon"></i>
              <span>{event.venue_name}</span>
            </div>
            <div className="time">
              <i className="fas fa-clock icon"></i>
              {dateInfo.time}
            </div>
          </div>
          <div className="card-footer">
            <div className="price">
              <span className="currency">{event.price_range}</span>
            </div>
            <div className="arrow-icon">
              <i className="fas fa-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default EventCard;
